import { CSSProperties } from 'react'
import { Container } from 'rsuite'
import { useTranslation } from 'react-i18next'
import BreadCrumb from './BreadCrumb'
import { useLayout } from './LayoutManager'
import project from '@client/stores/projectStore'
import ContentLogo from './ContentLogo'
import { activeKey, findTab, getActiveKey } from '@client/stores/tabsStore'

type TCmd = (action: string, data?: any, defaultValue?: any) => any
type TabListContentProps = { config: any }

const tabListContentStyle = {
    display: 'flex',
    overflow: 'auto',
} as CSSProperties

export default function TabContent({ config }: TabListContentProps) {
    const { t } = useTranslation()
    const { cmd } = useLayout()
    const tab = findTab(config.id)
    if (!tab) return null
    const ignoreProject = cmd('ignoreProjectExists', { activeKey: config.id, tab: config })
    if (!project.currentProject.value && !ignoreProject) return null
    //const result = cmd('getTabContent', { activeKey: config.id, tab: config, cmd })
    // console.log('Rendering tab:', tab.id, 'context:', tab.context, 'component:', tab.component)

    const result = cmd('getTabContent', {
        activeKey: getActiveKey(tab.context ?? 'main-tabs'),
        tab,
        cmd,
    })
    // console.log(result)
    if (result)
        return (
            <div className="tab-item-wrapper">
                <BreadCrumb config={tab} />
                <Container className="opentabs-content" style={tabListContentStyle}>
                    {result}
                </Container>
            </div>
        )

    return (
        <ContentLogo>
            <p>{t('No content found.')}</p>
        </ContentLogo>
    )
}
